import React, { useEffect, useState } from "react";
import HistogramPlot from "./HistogramPlot";
import ClassedHistogramPlot from "./ClassedHistogramPlot";
import HistogramTable from "./HistogramTable";
import { LoadingSpinnerSmall } from '../../../../../components/LoadingSpinnerSmall';
import { useStore } from '../../../providers/AppProvider';

interface Props {
  config: any,
  selectedLayerId: string | null,
  updateHistogramId: number,
  updateHistogramLoaded: boolean,
  dwFilters: any,
  setDwFilters: Function, 
  field:any,
  //onClick?: (depth: number) => void
}

const HistogramPlots = ({ field, config, selectedLayerId, updateHistogramId, updateHistogramLoaded, dwFilters, setDwFilters}: Props) => {

  const [plotConfigs, setPlotConfigs] = useState<any>(null);
  const [updateId, setUpdateId] = useState<number>(1);
  const [_crop, set_crop] = useState<string | null>(null);

  const { state: { crops }, orgId } = useStore();

  useEffect(() => {
      if (config && config?._histogramData?.histogramData){
        console.log("A022024 config?._histogramData?.histogramData", config?._histogramData?.histogramData)
        setPlotConfigs(config?._histogramData?.histogramData);
      }else{
        setPlotConfigs(null);
      }
      setUpdateId(prev => prev + 1 )
  }, [config, selectedLayerId, updateHistogramId, updateHistogramLoaded,/*plotConfigs, updateId*/]);
  
  useEffect(() => {
      //console.log("A022024 config", config)
      //console.log("selectedLayerId", selectedLayerId)
      //console.log("updateHistogramId", updateHistogramId)
      console.log("A022024 plotConfigs", plotConfigs)
      console.log("updateId", updateId)
      //console.log("updateHistogramLoaded", updateHistogramLoaded)
  }, [plotConfigs, updateId]);

  useEffect(() => {
    let _crop_filtered = crops.filter((k: any) => k.id === field.crop_id)[0];
    if (_crop_filtered){
      set_crop(_crop_filtered.name);
    }else{
      set_crop(null);
    }
  }, [field, crops]);

  let countHistogram = 0; 
  //console.log("C021524 plotConfigs", plotConfigs)
  //console.log("C021524 config?._histogramData?.histogramData", config?._histogramData?.histogramData)
  return (
    <>{
      plotConfigs
        ? Object.entries(plotConfigs).map(([key, value]) => {
          //console.log("A111723 key", key)
          //console.log("A111723 value", value)
          countHistogram++;
          return(
            <div
              key={`${countHistogram}histogramParent`}
            >
            {(countHistogram !== 1)
             ? <div 
                key={`${countHistogram}histogramSpacer`}
                style={{
                  height: "1px",
                  backgroundColor: "#dee2e6",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}></div>
              : <div
                key={`${countHistogram}histogramNoSpacer`}
                ></div>
            }
            { (value as any)?.classData
              ? <ClassedHistogramPlot
                  key={`${countHistogram}histogramPlot`}
                  passableKey={`${countHistogram}histogram`}
                  config={value} 
                  selectedLayerId={selectedLayerId}
                  updateHistogramId={updateHistogramId}
                  plotConfigs={plotConfigs}
                  updateId={updateId}
                  dwFilters={dwFilters}
                  setDwFilters={setDwFilters} 
                />
              : <HistogramPlot
                  key={`${countHistogram}histogramPlot`}
                  passableKey={`${countHistogram}histogram`}
                  config={value} 
                  selectedLayerId={selectedLayerId}
                  updateHistogramId={updateHistogramId}
                  plotConfigs={plotConfigs}
                  updateId={updateId}
                  dwFilters={dwFilters}
                  setDwFilters={setDwFilters} 
                />
            }
            { /*console.log("060524 crops", crops) } 
            { console.log("060524 field", field) } 
            { console.log("060524 _crop", _crop) */} 
            {(value as any)?.status?.data 
              ? (_crop === "Almonds")
                ? <HistogramTable
                    key={`${countHistogram}histogramTable`}
                    passableKey={`${countHistogram}histogram`}
                    config={value} 
                    selectedLayerId={selectedLayerId}
                    updateHistogramId={updateHistogramId}
                    plotConfigs={plotConfigs}
                    updateId={updateId}
                    dwFilters={dwFilters}
                    setDwFilters={setDwFilters} 
                  />
                : <></>
              : <></>
            }
            </div>
          )
        })
      : !updateHistogramLoaded
        ? <div className={"text-sm"} style={{ width:"100%", textAlign:"center" }}>
            {/*<div style={{ width:"100%", textAlign:"center"}}>
                <LoadingSpinnerSmall message="Loading Data..."></LoadingSpinnerSmall>
            </div>*/}
            <div className={"text-sm"} style={{ width:"100%", textAlign:"center", fontSize:"12px"}}>
                Loading data...
            </div>
          </div>
        : <div style={{ width:"100%", textAlign:"center" }}>
          <div className={"text-sm"} style={{ width:"100%", textAlign:"center", fontSize:"12px"}}>
              No data for this date.
          </div>
      </div>
    }</>
  );
}


export default HistogramPlots;